module.exports = __webpack_public_path__ + "static/media/East_Hall-f.f36ca7d5.webp";